<template>
  <div class="question-image">
    <v-img class="image-content" :src="question.image" :max-height="`calc(100vh - ${headerHeight}px)`">
      <slot></slot>
    </v-img>
  </div>
</template>

<script>
export default {
  name: 'question-image',
  props: {
    question: Object,
    headerHeight: Number
  }
};
</script>

<style lang="scss" scoped>
.question-image {
  height: 100%;
  flex: 1;
  & + div {
    flex: 1;
  }
}

.image-content {
  display: flex;
  align-items: center;
}
</style>
